export default __webpack_public_path__ + "static/media/card.af9024df.svg";